module.exports = __webpack_public_path__ + "static/media/CityPortalIcon.d739da16.svg";